// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"234":"0f0bd355","343":"ef5fb2df","744":"c623a3b9","900":"0f0bd355","953":"c623a3b9","966":"0f0bd355"}[chunkId] + ".chunk.css";
};